'use client';

import React, { useState, useEffect } from 'react';
import { Modal, Checkbox } from 'antd';

interface PermissionsModalProps {
    user: any;
    open: boolean;
    onClose: () => void;
    onSave: (userId: number, newPermissions: Record<string, boolean> | null) => Promise<void>;
}

const permissionList = [
    { key: 'customCategoriesMaterialsTests', label: 'Создание собственных категорий, материалов и тестов' },
    { key: 'editUserStatus', label: 'Изменение статуса пользователей' },
    { key: 'editUsersAccess', label: 'Включение/выключение пользователям доступа к материалам и тестам от главного администратора' },
];

export const PermissionsModal: React.FC<PermissionsModalProps> = ({user, open, onClose, onSave}) => {
    const [editingPermissions, setEditingPermissions] = useState<string[]>([]);

    useEffect(() => {
        if (user?.permissions) {
            setEditingPermissions(Object.keys(user.permissions));
        } else {
            setEditingPermissions([]);
        }
    }, [user]);

    const handleOk = async () => {
        const permissionsJSON = editingPermissions.length === 0
                ? null
                : Object.fromEntries(editingPermissions.map((key) => [key, true]));

        await onSave(user.id, permissionsJSON);
        onClose();
    };

    return (
        <Modal
            title={`Редактирование прав: ${user?.fio || user?.name || user?.email}`}
            open={open}
            onCancel={onClose}
            onOk={handleOk}
            okText="Сохранить"
            cancelText="Отмена"
        >
            <Checkbox.Group
                style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
                value={editingPermissions}
                onChange={(checked) => setEditingPermissions(checked as string[])}
            >
                {permissionList.map((p) => (
                    <Checkbox key={p.key} value={p.key}>
                        {p.label}
                    </Checkbox>
                ))}
            </Checkbox.Group>
        </Modal>
    );
};
